<!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
<!-- eslint-disable @angular-eslint/template/click-events-have-key-events -->
<cdk-accordion class="accordion">
  <cdk-accordion-item
    #accordionItem="cdkAccordionItem"
    [expanded]="printing ? true : false"
    class="accordion-item"
    role="button"
    tabindex="0">
    <div class="accordion-item-header" (click)="accordionItem.toggle()">
      <span class="title">Erklärung der ICF und Scores</span>
      @if (!printing) {
        @if (accordionItem.expanded) {
          <span class="material-icons"> expand_less </span>
        } @else {
          <span class="material-icons"> expand_more </span>
        }
      }
    </div>
    <div class="accordion-item-body" role="region" [style.display]="accordionItem.expanded ? '' : 'none'">
      <p class="description">
        Die Internationale Klassifikation der Funktionsfähigkeit, Behinderung und Gesundheit (ICF) der
        Weltgesundheitsorganisation (WHO) bietet ein umfassendes Modell, das den Gesundheitszustand eines Menschen aus
        verschiedenen Perspektiven beschreibt. Anstatt sich nur auf Diagnosen zu konzentrieren, betrachtet die ICF die
        Wechselwirkungen zwischen Körperfunktionen, Aktivitäten und der Teilhabe am gesellschaftlichen Leben sowie die
        Einflüsse durch Umwelt- und personenbezogene Faktoren. Weitere Informationen sind zu finden im REHADAT
        ICF-Lotsen:
        <a target="_blank" href="https://www.rehadat-icf.de/de/ueber-die-icf/was-ist-die-icf/">
          https://www.rehadat-icf.de/de/ueber-die-icf/was-ist-die-icf/</a
        >
      </p>
      <p class="description">
        Die ICF-Scores von 0 bis 4 werden verwendet, um den Grad der Beeinträchtigung oder Funktionsfähigkeit in
        verschiedenen Kategorien zu bewerten. Sie bieten eine standardisierte Skala, die den Schweregrad der
        Einschränkungen beschreibt:
      </p>
      <app-icf-description-table></app-icf-description-table>
    </div>
  </cdk-accordion-item>
</cdk-accordion>  
@if (!printing) {
  <div class="spacer"></div>
  @if (showIcfScoreReviewWarning()) {
    <div class="warning">
      <h2><mat-icon>event</mat-icon> ICF-Scores nach neuen Testungen aktualisieren</h2>
      <p>
        Seit der letzten Änderung am Bericht vom {{ lastIcfUpdateTimeGermanDate() }} wurden neue Testungen durchgeführt. Bitte prüfen Sie die ICF-Scores.</p>
        
      <p>
        Assessments mit neuen Testungen sind farblich orange hinterlegt. Nach der Prüfung bestätigen Sie die ICF-Scores um diese Warnung und die Markierungen zu entfernen.
      </p>
      <button
        mat-flat-button
        color="secondary"
        (click)="onApplyAllIcfScoresChecked()">
        ICH HABE DIE ICF-SCORES ÜBERPRÜFT
      </button>
    </div>
  }
  <div class="button-container no-print">
    <div class="search">
      <!-- <input type="text" />
      <i (click)="search()" (keypress)="search()" class="material-icons">search</i> -->
      <mat-checkbox
        class=""
        [(ngModel)]="isCategoryDescriptionsEnabled"
        (click)="onChangeCategoryDesciptionEnabled()"
        labelPosition="after">
        Kategorien beschreiben
      </mat-checkbox>

    </div>
    <button
      mat-flat-button
      class="alle-icf-scores-button"
      color="secondary"
      (click)="onApplyAllIcfScoresClicked()">
      ALLE ICF-SCORES ÜBERNEHMEN
    </button>

    <!-- <button
      class="align-right no-print"
      mat-raised-button
      color="primary"
      (click)="printSimple()"
      title="Für beste Druckergebnisse bitte einen Chrome oder Edge Browser verwenden">
      Drucken
    </button> -->
    <!-- <button
      class="align-right"
      mat-raised-button
      color="primary"
      printSectionId="print-section"
      [useExistingCss]="true"
      [previewOnly]="true"
      [printDelay]="1000"
      ngxPrint
      (click)="print()">
      Drucken
    </button> -->
  </div>
} @else {
  <div class="spacer"></div>
}

@if (patient()) {
  <div id="print-section" class="table print-table">
    <div class="report-row table-header do-print print-header">
      <div class="top">
        <div class="left print-cell">
          <div class="title">Kategorie</div>
          <div class="score">ICF-Score</div>
        </div>
        <div class="note print-cell">Kommentar zum ICF-Score (optional)</div>
        <div class="right print-cell">Einschränkung laut Test</div>
      </div>
    </div>
    @for (item of reportList() ?? []; track $index) {
      @if(!printing || printing && item.icfScoreSelected !== undefined && item.icfScoreSelected > -1) {
        <app-report-row
        [id]="item.icfCategory"
        [isCategoryDesciptionEnabled]="printing ? true : isCategoryDescriptionsEnabled"
        [item]="item"
        [ngClass]="{ 'warning-row': item.isAssessmentLaterWarning && showIcfScoreReviewWarning() }"
        class="do-print print-row"></app-report-row>
      }

    }

    @let hasARAT = assessmentChartDataSets()?.ARAT?.length ?? 0 > 0; 
    @let hasBBS = assessmentChartDataSets()?.BBS?.length ?? 0 > 0; 
    @let hasBBT = assessmentChartDataSets()?.BBT?.length ?? 0 > 0; 
    @let hasNHPT = assessmentChartDataSets()?.NHPT?.length ?? 0 > 0; 
    @let hasTUG = assessmentChartDataSets()?.TUG?.length ?? 0 > 0; 
    @if (printing && (hasARAT || hasBBS || hasBBT || hasNHPT || hasTUG)) {
      
      <div class="graph">
        <app-graph [patientId]="patientId"></app-graph>
      </div>
      <!-- @TODO: nach anzahl der graphen die höhe variieren. Oder nach länge des Docs. 
      btw: je länger die kommentare sind, also je mehr zeilen in den tabellen, dest niedriger muss das leere addendum  sein!
      -->
      <!-- <div [class]="'bottom-space bottom-space-' + assessmentChartDataSetCount()"> -->
      <div class="end-of-document">
        <!-- <p>Das ist das Ende des Druckdokuments.</p> -->
      </div>
      <!-- </div> -->
    }
    
    @if (printing) {
      <!-- <cdk-accordion class="accordion page-break">
        <cdk-accordion-item
          #accordionItem="cdkAccordionItem"
          [expanded]="printing ? true : false"
          class="accordion-item"
          role="button"
          tabindex="0">
          <div class="accordion-item-header" (click)="accordionItem.toggle()">
            <span class="title">Erklärung der ICF und Scores</span>
            @if (!printing) {
              @if (accordionItem.expanded) {
                <span class="material-icons"> expand_less </span>
              } @else {
                <span class="material-icons"> expand_more </span>
              }
            }
          </div>
          <div class="accordion-item-body" role="region" [style.display]="accordionItem.expanded ? '' : 'none'">
            <p class="description">
              Die Internationale Klassifikation der Funktionsfähigkeit, Behinderung und Gesundheit (ICF) der
              Weltgesundheitsorganisation (WHO) bietet ein umfassendes Modell, das den Gesundheitszustand eines Menschen aus
              verschiedenen Perspektiven beschreibt. Anstatt sich nur auf Diagnosen zu konzentrieren, betrachtet die ICF die
              Wechselwirkungen zwischen Körperfunktionen, Aktivitäten und der Teilhabe am gesellschaftlichen Leben sowie die
              Einflüsse durch Umwelt- und personenbezogene Faktoren. Weitere Informationen sind zu finden im REHADAT
              ICF-Lotsen:
              <a target="_blank" href="https://www.rehadat-icf.de/de/ueber-die-icf/was-ist-die-icf/">
                https://www.rehadat-icf.de/de/ueber-die-icf/was-ist-die-icf/</a
              >
            </p>
            <p class="description">
              Die ICF-Scores von 0 bis 4 werden verwendet, um den Grad der Beeinträchtigung oder Funktionsfähigkeit in
              verschiedenen Kategorien zu bewerten. Sie bieten eine standardisierte Skala, die den Schweregrad der
              Einschränkungen beschreibt:
            </p>
            <app-icf-description-table></app-icf-description-table>
          </div>
        </cdk-accordion-item>
      </cdk-accordion> -->

      <div class="last-page-footer">
        <br>
        <p>
          Erstellt von {{ officeName }} am {{ currentDate | date: 'dd.MM.yyyy' }}.
        </p>
        <p>
          Dieser Bericht basiert auf manuellen Eingaben des Therapeuten. Theradea stellt keine medizinische Bewertung oder Zweckbestimmung im Sinne der MDR (EU) 2017/745 bereit.
        </p>
      </div>
    }
  </div>
} @else {
  <br />
  <br />
  Lade Patientendaten...
}


